export class NoWhatsappIntegrationError extends Error {
    constructor(message: string) {
        super()
        this.message = message
    }
}
